import { Typography } from '@mui/material';
import he from 'he';
import sanitizeHtml from 'sanitize-html';
import { getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess as SEOSegmentationSearchResultsSuccessType } from '@/__generated__/getSearchResults';
import { SEARCH_RESULT_TYPE, ServiceIdForMember } from '@/constants';
import SearchResults from './SearchResults';

interface HybridSearchResultsProps {
  caregiverSearchResults: SEOSegmentationSearchResultsSuccessType['caregiverSearchResults'];
  isClientSearchResultsQuery: boolean;
  providerSearchResults: SEOSegmentationSearchResultsSuccessType['providerSearchResults'];
  serviceId: string;
  serviceIdForMember: ServiceIdForMember;
  smbHeadline: string;
}

const HybridSearchResults = ({
  caregiverSearchResults,
  isClientSearchResultsQuery,
  providerSearchResults,
  serviceId,
  smbHeadline,
  serviceIdForMember,
}: HybridSearchResultsProps) => {
  return (
    <>
      <SearchResults
        results={caregiverSearchResults}
        resultType={SEARCH_RESULT_TYPE.CAREGIVER}
        isClientSearchResultsQuery={isClientSearchResultsQuery}
        serviceId={serviceId}
        serviceIdForMember={serviceIdForMember}
      />
      <Typography
        align="center"
        variant="h3"
        my={4}
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(he.decode(smbHeadline)),
        }}
      />
      <SearchResults
        results={providerSearchResults}
        resultType={SEARCH_RESULT_TYPE.PROVIDER}
        isClientSearchResultsQuery={isClientSearchResultsQuery}
        serviceId={serviceId}
        serviceIdForMember={serviceIdForMember}
      />
    </>
  );
};

export default HybridSearchResults;
